export default {
  currentUser: null
}
